import Button from '@insided/control/uikit/Button'

interface UserProfileActionProps {
  authorId: string
  loggedInUserId: string | undefined
}

const UserProfileActions = ({ authorId, loggedInUserId }: UserProfileActionProps) => {
  const privateMessageUrl = `/privateMessages/overview#conversation/${authorId}`
  return (
    <div className='post__panel-footer--user-action-box'>
      {authorId &&
        loggedInUserId !== authorId &&
          <Button onClick={() => window.open(privateMessageUrl, '_self')}>Message</Button>}
    </div>
  )
}

export default UserProfileActions
